import styled from 'styled-components';

import { THEME_COLORS } from '../../utils/colors';
import { ReactComponent as CopyIconComponent } from '../../images/copy.inline.svg';
import { Modal as ModalComponent } from '../modal';
import { CIRCLE_WIDTH, SOCIAL_MEDIA_ICONS_COUNT } from './shareModal.constants';

const getGridGapForSmallerPhones = `calc((100% - (${CIRCLE_WIDTH}px * ${SOCIAL_MEDIA_ICONS_COUNT})) / ${
  SOCIAL_MEDIA_ICONS_COUNT - 1
})`;

export const CircleWrapper = styled.div`
  width: ${CIRCLE_WIDTH}px;
  height: ${CIRCLE_WIDTH}px;
  border-radius: 50px;
  background-color: ${THEME_COLORS.VERY_LIGHT_PINK};
  margin-bottom: 34px;
`;

export const IconsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 60px);
  grid-column-gap: ${getGridGapForSmallerPhones};
`;

export const IconWrapper = styled.div`
  font-size: 13px;
  letter-spacing: -0.1px;
  color: ${THEME_COLORS.GREYISH_BROWN};
  text-align: center;
`;

export const ModalContent = styled.div``;

export const InputWrapper = styled.div`
  background-color: ${THEME_COLORS.VERY_LIGHT_PINK};
  display: flex;
  margin-bottom: 30px;
`;

export const Input = styled.input`
  border: none;
  margin: 0;
  padding: 15px;
  background-color: ${THEME_COLORS.VERY_LIGHT_PINK};
  width: 100%;
  color: ${THEME_COLORS.BROWN_GREY};
  font-size: 14px;
  line-height: 1.21;
  outline: none;
`;

export const CopyButton = styled.button`
  border: none;
  margin: 0;
  padding: 0;
  width: auto;
  margin-left: auto;
  padding: 15px;
  cursor: pointer;
  outline: none;
`;

export const CopyIcon = styled(CopyIconComponent)`
  width: 12px;
  height: 12px;
`;

export const Title = styled.p`
  font-size: 21px;
  letter-spacing: -0.15px;
  text-align: center;
  color: ${THEME_COLORS.GREYISH_BROWN};
  text-align: left;
  margin-bottom: 21px;
`;

export const Modal = styled(ModalComponent)`
  padding: 36px;
`;

export const Anchor = styled.a``;
